import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminPanel = () => {
  const [secret, setSecret] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const [formData, setFormData] = useState({
    title: '',
    content: '',
    type: 'general',
  });

  const handleLogin = (e) => {
    e.preventDefault();
    if (secret.trim() !== '') {
      setAuthenticated(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      await axios.post(`${API}/updates`, formData, {
        headers: {
          'x-admin-secret': secret,
        },
      });
      setMessage({ type: 'success', text: 'Update posted successfully!' });
      setFormData({ title: '', content: '', type: 'general' }); // Reset form
    } catch (error) {
      if (error.response?.status === 401) {
        setMessage({ type: 'error', text: 'Invalid Admin Secret! Access Denied.' });
        setAuthenticated(false); // kick them out
      } else {
        setMessage({ type: 'error', text: 'Error posting update. Check console.' });
      }
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: 8,
    border: '1px solid #ccc',
    fontFamily: 'var(--font-primary)',
    fontSize: 15,
    marginBottom: 16,
  };

  if (!authenticated) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f4f4' }}>
        <form onSubmit={handleLogin} style={{ background: '#fff', padding: 40, borderRadius: 16, width: '100%', maxWidth: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontFamily: 'var(--font-primary)', marginBottom: 20 }}>Admin Login</h2>
          <input
            type="password"
            placeholder="Enter Admin Secret"
            value={secret}
            onChange={e => setSecret(e.target.value)}
            style={inputStyle}
            required
          />
          <button className="btn-primary" type="submit" style={{ width: '100%', justifyContent: 'center' }}>
            Enter
          </button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', padding: 40, background: '#f4f4f4' }}>
      <div style={{ background: '#fff', padding: 40, borderRadius: 16, width: '100%', maxWidth: 600, margin: '0 auto', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <h2 style={{ fontFamily: 'var(--font-primary)', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Post a New Update
          <button onClick={() => setAuthenticated(false)} style={{ fontSize: 13, background: 'none', border: 'none', color: '#cc0000', cursor: 'pointer' }}>Logout</button>
        </h2>
        
        {message && (
          <div style={{ padding: 16, borderRadius: 8, marginBottom: 20, background: message.type === 'success' ? '#d4edda' : '#f8d7da', color: message.type === 'success' ? '#155724' : '#721c24' }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 'bold' }}>Update Type</label>
          <select 
            value={formData.type} 
            onChange={e => setFormData({ ...formData, type: e.target.value })}
            style={inputStyle}
          >
            <option value="general">📌 General Update</option>
            <option value="college_added">🏛️ College Added</option>
            <option value="announcement">📢 Announcement</option>
            <option value="feature">✨ New Feature</option>
          </select>

          <label style={{ display: 'block', marginBottom: 6, fontWeight: 'bold' }}>Title</label>
          <input
            type="text"
            placeholder="e.g. Bharati Vidyapeeth Added!"
            value={formData.title}
            onChange={e => setFormData({ ...formData, title: e.target.value })}
            style={inputStyle}
            required
          />

          <label style={{ display: 'block', marginBottom: 6, fontWeight: 'bold' }}>Content</label>
          <textarea
            placeholder="Write the details here..."
            value={formData.content}
            onChange={e => setFormData({ ...formData, content: e.target.value })}
            style={{ ...inputStyle, minHeight: 120, resize: 'vertical' }}
            required
          />

          <button className="btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
            {loading ? 'Posting...' : 'Post Update to Live Website'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminPanel;
